import script from "./Card.vue?vue&type=script&setup=true&lang=js"
export * from "./Card.vue?vue&type=script&setup=true&lang=js"

import "./Card.vue?vue&type=style&index=0&id=4242aa1f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4242aa1f"]])

export default __exports__